<div class="container-fluid">
  <h4>{{'MarketMonitor.header' | translate}}</h4>
  <div class="mat-elevation-z8 mt-3">
    <div class="scrollableTable">
      <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="markets">
          <th mat-header-cell *matHeaderCellDef style="width: 50%;"> {{'MarketMonitor.thMarkets' | translate}}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'clickable':service.currentUser.userRole !== staffRoleName}" (click)="OnClickMarket(element)">{{element.description}} ({{element.code}})</td>
        </ng-container>

        <ng-container matColumnDef="quorum">
          <th mat-header-cell *matHeaderCellDef style="width: 5%;"> {{'MarketMonitor.thQuorum' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.contributors}}/{{element.quorum}}</td>
        </ng-container>

        <ng-container matColumnDef="timeToOpen">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'MarketMonitor.thTimeToOpen' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.timeToOpen}}</td>
        </ng-container>
        
        <ng-container matColumnDef="timeToClose">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'MarketMonitor.thTimeToClose' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.timeToClose}}</td>
        </ng-container>

        <ng-container matColumnDef="timeToPublish">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'MarketMonitor.thTimeToPublish' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.timeToPublish}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="width: 15%;"> {{'MarketMonitor.thStatus' | translate}}</th>
          <td mat-cell *matCellDef="let element"><mat-icon class="{{element.statusColor}}">{{element.statusIcon}}</mat-icon> <span style="vertical-align: super;">{{element.status}}</span></td>
        </ng-container>

        <ng-container matColumnDef="loading">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
        </ng-container>

        <ng-container matColumnDef="noData">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'MarketMonitor.tblNoData' | translate}}... </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="{'hide':(dataSource!=null && marketsLength != 0) || isLoading=== true}"></tr>

      </table>
    </div>
  </div>
</div>